export default __webpack_public_path__ + "static/media/SportKLS_LateralDer.d3caa27f.webp";